import React, { Component } from "react";
import Inform from './InitInform';
import Landing from '../../landing/containers/LandingContainer';


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Dashboard';



class LandingInformContainer extends Component {

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }
  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <Inform onChangeRoute={this.onChangeRoute} />
      </Landing>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(LandingInformContainer);